
import { useEffect, useState } from "react";
import  "./Testinomial.css"
import { Button, Modal,Carousel,Card } from "react-bootstrap";

export default function Testimonial() {
    const [isMobile, setIsMobile] = useState(false)
    const [isSingleDevice,setIsSingleDevice]=useState(false)
    const handleResize = () => {

        if (window.innerWidth < 576){
          setIsSingleDevice(true)
        }
        else{
          setIsSingleDevice(false)
        }
        if (window.innerWidth < 767 && window.innerWidth >= 576) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
      }
      
      // create an event listener
      useEffect(() => {
        window.addEventListener("resize", handleResize)
      },[])
    const reduceReviews = (acc, cur, index) => {
        if(isSingleDevice){
          const groupIndex = Math.floor(index / 1);
          if (!acc[groupIndex]) acc[groupIndex] = [];
          acc[groupIndex].push(cur);
          console.log(acc);
          return acc;
        }
        if(isMobile){
          const groupIndex = Math.floor(index / 2);
          if (!acc[groupIndex]) acc[groupIndex] = [];
          acc[groupIndex].push(cur);
          console.log(acc);
          return acc;
        }
        const groupIndex = Math.floor(index / 3);
        if (!acc[groupIndex]) acc[groupIndex] = [];
        acc[groupIndex].push(cur);
        console.log(acc);
        return acc;
      };
    
      const reviews = [
        {
          id: 1,
          image: "https://images.unsplash.com/photo-1639747280804-dd2d6b3d88ac?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1374&q=80",
          content: "Working with 24k Realty Group was an absolute pleasure! As first-time home buyers, we had a lot of questions and uncertainty. Our agent patiently walked us through every step and found us the perfect home within our budget. Highly recommend them for their professionalism and genuine care!",
          author: "John Smith"
        },
        {
          id: 2,
          image: "https://img.freepik.com/free-photo/smiling-caucasian-guy-with-beard-looking-happy_176420-18707.jpg?w=740&t=st=1696492432~exp=1696493032~hmac=dae95f5e4cb70a474035a94906d15537e6a337dde103b4e87e037ef83aa0bfdd",
          content: "The team at 24k Realty Group knows the market inside out. Their guidance helped us sell our home above asking price in just 10 days. We appreciated the honest communication, detailed reports, and regular updates throughout the process. We’ll definitely work with them again!",
          author: "David Williams"
        },
        {
          id: 3,
          image: "https://img.freepik.com/free-photo/portrait-beautiful-young-woman-standing-grey-wall_231208-10760.jpg?w=740&t=st=1696492491~exp=1696493091~hmac=432bc45d2edf37767ae5e5b56779b09ac92ab8f01f8bc879dcd0262ac07642bc",
          content: "As a landlord, I’ve worked with several property managers over the years, and 24k Realty Group stands out. They handle everything from tenant screening to maintenance with utmost professionalism. I finally feel at ease knowing my property is in good hands.",
          author: "Jane Johnson"
        },
        {
          id: 4,
          image: "https://img.freepik.com/free-photo/close-up-young-successful-man-smiling-camera-standing-casual-outfit-against-blue-background_1258-66609.jpg?w=740&t=st=1696492520~exp=1696493120~hmac=cd4557dcee475e4d3997f9d3b0f1388d19d72e20b97249e6cb689163c5c0a300",
          content: "What I appreciated most about 24k Realty Group was how personalized the service felt. Our agent genuinely listened to what we needed, didn’t push us into anything, and was available whenever we needed help—even after hours!",
          author: "Michael Anderson"
        },
        {
          id: 5,
          image: "https://img.freepik.com/free-photo/young-beautiful-woman-pink-warm-sweater-natural-look-smiling-portrait-isolated-long-hair_285396-896.jpg?w=740&t=st=1696492571~exp=1696493171~hmac=7b3e2d888d72662600dbabe347ed82cc8998e295242e92a9e2acb9e85f42e73f",
          content: "I recently rented a property through 24k Realty Group and had a seamless experience. The process was fast, transparent, and stress-free. The staff was friendly and quick to respond to any queries. Best rental experience I’ve had so far!",
          author: "Sarah Davis"
        }
      ];
      
      // These reviews now have generic content while keeping the same images.
      
      
      // These reviews are now more generic and suitable for a general property listing/real estate website.
      
      
      // Now, the array contains real property reviews and real author names.
      
  return (
    <div className="testinomials">
      <Carousel >
          {reviews.reduce(reduceReviews, []).map((review, index) => (

            <Carousel.Item key={index}>
            <div className="d-flex justify-content-center" style={{gap:"50px"}}>
              {review.map((item, index) => {
                return (
                  <Card key={index} style={{ width: "25rem" }}>
                    <Card.Img variant="top" src={item.image} />
                    <Card.Body>
                     
                      
                <h6>{item.content} </h6>
                <h4>-{item.author}</h4>
                    </Card.Body>
                  </Card>
                );
              })}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}
